export const COLLECTIONS_LOAD_PROJECT_COLLECTIONS_BEGIN =
  'COLLECTIONS_LOAD_PROJECT_COLLECTIONS_BEGIN';
export const COLLECTIONS_LOAD_PROJECT_COLLECTIONS_SUCCESS =
  'COLLECTIONS_LOAD_PROJECT_COLLECTIONS_SUCCESS';
export const COLLECTIONS_LOAD_PROJECT_COLLECTIONS_FAILURE =
  'COLLECTIONS_LOAD_PROJECT_COLLECTIONS_FAILURE';
export const COLLECTIONS_LOAD_PROJECT_COLLECTIONS_DISMISS_ERROR =
  'COLLECTIONS_LOAD_PROJECT_COLLECTIONS_DISMISS_ERROR';
export const COLLECTIONS_COLLECTION_SETTING = 'COLLECTIONS_COLLECTION_SETTING';
export const COLLECTIONS_CLOSE_COLLECTION_SETTING_PAGE =
  'COLLECTIONS_CLOSE_COLLECTION_SETTING_PAGE';
export const COLLECTIONS_LOAD_PROJECT_COLLECTION_DETAIL_BEGIN =
  'COLLECTIONS_LOAD_PROJECT_COLLECTION_DETAIL_BEGIN';
export const COLLECTIONS_LOAD_PROJECT_COLLECTION_DETAIL_SUCCESS =
  'COLLECTIONS_LOAD_PROJECT_COLLECTION_DETAIL_SUCCESS';
export const COLLECTIONS_LOAD_PROJECT_COLLECTION_DETAIL_FAILURE =
  'COLLECTIONS_LOAD_PROJECT_COLLECTION_DETAIL_FAILURE';
export const COLLECTIONS_LOAD_PROJECT_COLLECTION_DETAIL_DISMISS_ERROR =
  'COLLECTIONS_LOAD_PROJECT_COLLECTION_DETAIL_DISMISS_ERROR';
export const COLLECTIONS_UPDATE_COLLECTIONS_BEGIN = 'COLLECTIONS_UPDATE_COLLECTIONS_BEGIN';
export const COLLECTIONS_UPDATE_COLLECTIONS_SUCCESS = 'COLLECTIONS_UPDATE_COLLECTIONS_SUCCESS';
export const COLLECTIONS_UPDATE_COLLECTIONS_FAILURE = 'COLLECTIONS_UPDATE_COLLECTIONS_FAILURE';
export const COLLECTIONS_UPDATE_COLLECTIONS_DISMISS_ERROR =
  'COLLECTIONS_UPDATE_COLLECTIONS_DISMISS_ERROR';
export const COLLECTIONS_CREATE_COLLECTION_BEGIN = 'COLLECTIONS_CREATE_COLLECTION_BEGIN';
export const COLLECTIONS_CREATE_COLLECTION_SUCCESS = 'COLLECTIONS_CREATE_COLLECTION_SUCCESS';
export const COLLECTIONS_CREATE_COLLECTION_FAILURE = 'COLLECTIONS_CREATE_COLLECTION_FAILURE';
export const COLLECTIONS_CREATE_COLLECTION_DISMISS_ERROR =
  'COLLECTIONS_CREATE_COLLECTION_DISMISS_ERROR';
export const COLLECTIONS_DELETE_COLLECTION_BEGIN = 'COLLECTIONS_DELETE_COLLECTION_BEGIN';
export const COLLECTIONS_DELETE_COLLECTION_SUCCESS = 'COLLECTIONS_DELETE_COLLECTION_SUCCESS';
export const COLLECTIONS_DELETE_COLLECTION_FAILURE = 'COLLECTIONS_DELETE_COLLECTION_FAILURE';
export const COLLECTIONS_DELETE_COLLECTION_DISMISS_ERROR =
  'COLLECTIONS_DELETE_COLLECTION_DISMISS_ERROR';
export const COLLECTIONS_EDIT_FIELD_BEGIN = 'COLLECTIONS_EDIT_FIELD_BEGIN';
export const COLLECTIONS_EDIT_FIELD_SUCCESS = 'COLLECTIONS_EDIT_FIELD_SUCCESS';
export const COLLECTIONS_EDIT_FIELD_FAILURE = 'COLLECTIONS_EDIT_FIELD_FAILURE';
export const COLLECTIONS_EDIT_FIELD_DISMISS_ERROR = 'COLLECTIONS_EDIT_FIELD_DISMISS_ERROR';
export const COLLECTIONS_DELETE_FIELD_BEGIN = 'COLLECTIONS_DELETE_FIELD_BEGIN';
export const COLLECTIONS_DELETE_FIELD_SUCCESS = 'COLLECTIONS_DELETE_FIELD_SUCCESS';
export const COLLECTIONS_DELETE_FIELD_FAILURE = 'COLLECTIONS_DELETE_FIELD_FAILURE';
export const COLLECTIONS_DELETE_FIELD_DISMISS_ERROR = 'COLLECTIONS_DELETE_FIELD_DISMISS_ERROR';
export const COLLECTIONS_CREATE_NEW_FIELD_BEGIN = 'COLLECTIONS_CREATE_NEW_FIELD_BEGIN';
export const COLLECTIONS_CREATE_NEW_FIELD_SUCCESS = 'COLLECTIONS_CREATE_NEW_FIELD_SUCCESS';
export const COLLECTIONS_CREATE_NEW_FIELD_FAILURE = 'COLLECTIONS_CREATE_NEW_FIELD_FAILURE';
export const COLLECTIONS_CREATE_NEW_FIELD_DISMISS_ERROR =
  'COLLECTIONS_CREATE_NEW_FIELD_DISMISS_ERROR';
export const COLLECTIONS_DELETE_CONSTRUCTOR_BEGIN = 'COLLECTIONS_DELETE_CONSTRUCTOR_BEGIN';
export const COLLECTIONS_DELETE_CONSTRUCTOR_SUCCESS = 'COLLECTIONS_DELETE_CONSTRUCTOR_SUCCESS';
export const COLLECTIONS_DELETE_CONSTRUCTOR_FAILURE = 'COLLECTIONS_DELETE_CONSTRUCTOR_FAILURE';
export const COLLECTIONS_DELETE_CONSTRUCTOR_DISMISS_ERROR =
  'COLLECTIONS_DELETE_CONSTRUCTOR_DISMISS_ERROR';
export const COLLECTIONS_CREATE_COLLECTION_CONSTRUCTOR_BEGIN =
  'COLLECTIONS_CREATE_COLLECTION_CONSTRUCTOR_BEGIN';
export const COLLECTIONS_CREATE_COLLECTION_CONSTRUCTOR_SUCCESS =
  'COLLECTIONS_CREATE_COLLECTION_CONSTRUCTOR_SUCCESS';
export const COLLECTIONS_CREATE_COLLECTION_CONSTRUCTOR_FAILURE =
  'COLLECTIONS_CREATE_COLLECTION_CONSTRUCTOR_FAILURE';
export const COLLECTIONS_CREATE_COLLECTION_CONSTRUCTOR_DISMISS_ERROR =
  'COLLECTIONS_CREATE_COLLECTION_CONSTRUCTOR_DISMISS_ERROR';
export const COLLECTIONS_ADD_UTILITY_FUNCTION_TO_COLLECTION_BEGIN =
  'COLLECTIONS_ADD_UTILITY_FUNCTION_TO_COLLECTION_BEGIN';
export const COLLECTIONS_ADD_UTILITY_FUNCTION_TO_COLLECTION_SUCCESS =
  'COLLECTIONS_ADD_UTILITY_FUNCTION_TO_COLLECTION_SUCCESS';
export const COLLECTIONS_ADD_UTILITY_FUNCTION_TO_COLLECTION_FAILURE =
  'COLLECTIONS_ADD_UTILITY_FUNCTION_TO_COLLECTION_FAILURE';
export const COLLECTIONS_ADD_UTILITY_FUNCTION_TO_COLLECTION_DISMISS_ERROR =
  'COLLECTIONS_ADD_UTILITY_FUNCTION_TO_COLLECTION_DISMISS_ERROR';
export const COLLECTIONS_DELETE_UITILITY_FUNCTION_BEGIN =
  'COLLECTIONS_DELETE_UITILITY_FUNCTION_BEGIN';
export const COLLECTIONS_DELETE_UITILITY_FUNCTION_SUCCESS =
  'COLLECTIONS_DELETE_UITILITY_FUNCTION_SUCCESS';
export const COLLECTIONS_DELETE_UITILITY_FUNCTION_FAILURE =
  'COLLECTIONS_DELETE_UITILITY_FUNCTION_FAILURE';
export const COLLECTIONS_DELETE_UITILITY_FUNCTION_DISMISS_ERROR =
  'COLLECTIONS_DELETE_UITILITY_FUNCTION_DISMISS_ERROR';
export const COLLECTIONS_UPDATE_CONSTANT_OF_COLLECTION_BEGIN =
  'COLLECTIONS_UPDATE_CONSTANT_OF_COLLECTION_BEGIN';
export const COLLECTIONS_UPDATE_CONSTANT_OF_COLLECTION_SUCCESS =
  'COLLECTIONS_UPDATE_CONSTANT_OF_COLLECTION_SUCCESS';
export const COLLECTIONS_UPDATE_CONSTANT_OF_COLLECTION_FAILURE =
  'COLLECTIONS_UPDATE_CONSTANT_OF_COLLECTION_FAILURE';
export const COLLECTIONS_UPDATE_CONSTANT_OF_COLLECTION_DISMISS_ERROR =
  'COLLECTIONS_UPDATE_CONSTANT_OF_COLLECTION_DISMISS_ERROR';
export const COLLECTIONS_DELETE_COLLECTION_CONSTANT_BEGIN =
  'COLLECTIONS_DELETE_COLLECTION_CONSTANT_BEGIN';
export const COLLECTIONS_DELETE_COLLECTION_CONSTANT_SUCCESS =
  'COLLECTIONS_DELETE_COLLECTION_CONSTANT_SUCCESS';
export const COLLECTIONS_DELETE_COLLECTION_CONSTANT_FAILURE =
  'COLLECTIONS_DELETE_COLLECTION_CONSTANT_FAILURE';
export const COLLECTIONS_DELETE_COLLECTION_CONSTANT_DISMISS_ERROR =
  'COLLECTIONS_DELETE_COLLECTION_CONSTANT_DISMISS_ERROR';
export const COLLECTIONS_CREATE_COLLECTION_CONSTANT_BEGIN =
  'COLLECTIONS_CREATE_COLLECTION_CONSTANT_BEGIN';
export const COLLECTIONS_CREATE_COLLECTION_CONSTANT_SUCCESS =
  'COLLECTIONS_CREATE_COLLECTION_CONSTANT_SUCCESS';
export const COLLECTIONS_CREATE_COLLECTION_CONSTANT_FAILURE =
  'COLLECTIONS_CREATE_COLLECTION_CONSTANT_FAILURE';
export const COLLECTIONS_CREATE_COLLECTION_CONSTANT_DISMISS_ERROR =
  'COLLECTIONS_CREATE_COLLECTION_CONSTANT_DISMISS_ERROR';
export const COLLECTIONS_ADD_QUERY_TO_COLLECTION_BEGIN =
  'COLLECTIONS_ADD_QUERY_TO_COLLECTION_BEGIN';
export const COLLECTIONS_ADD_QUERY_TO_COLLECTION_SUCCESS =
  'COLLECTIONS_ADD_QUERY_TO_COLLECTION_SUCCESS';
export const COLLECTIONS_ADD_QUERY_TO_COLLECTION_FAILURE =
  'COLLECTIONS_ADD_QUERY_TO_COLLECTION_FAILURE';
export const COLLECTIONS_ADD_QUERY_TO_COLLECTION_DISMISS_ERROR =
  'COLLECTIONS_ADD_QUERY_TO_COLLECTION_DISMISS_ERROR';
export const COLLECTIONS_UPDATE_QUERY_OF_COLLECTION_BEGIN =
  'COLLECTIONS_UPDATE_QUERY_OF_COLLECTION_BEGIN';
export const COLLECTIONS_UPDATE_QUERY_OF_COLLECTION_SUCCESS =
  'COLLECTIONS_UPDATE_QUERY_OF_COLLECTION_SUCCESS';
export const COLLECTIONS_UPDATE_QUERY_OF_COLLECTION_FAILURE =
  'COLLECTIONS_UPDATE_QUERY_OF_COLLECTION_FAILURE';
export const COLLECTIONS_UPDATE_QUERY_OF_COLLECTION_DISMISS_ERROR =
  'COLLECTIONS_UPDATE_QUERY_OF_COLLECTION_DISMISS_ERROR';
export const COLLECTIONS_DELETE_COLLECTION_QUERY_BEGIN =
  'COLLECTIONS_DELETE_COLLECTION_QUERY_BEGIN';
export const COLLECTIONS_DELETE_COLLECTION_QUERY_SUCCESS =
  'COLLECTIONS_DELETE_COLLECTION_QUERY_SUCCESS';
export const COLLECTIONS_DELETE_COLLECTION_QUERY_FAILURE =
  'COLLECTIONS_DELETE_COLLECTION_QUERY_FAILURE';
export const COLLECTIONS_DELETE_COLLECTION_QUERY_DISMISS_ERROR =
  'COLLECTIONS_DELETE_COLLECTION_QUERY_DISMISS_ERROR';
export const COLLECTIONS_UPDATE_CONSTRAINT_OF_COLLECTION_BEGIN =
  'COLLECTIONS_UPDATE_CONSTRAINT_OF_COLLECTION_BEGIN';
export const COLLECTIONS_UPDATE_CONSTRAINT_OF_COLLECTION_SUCCESS =
  'COLLECTIONS_UPDATE_CONSTRAINT_OF_COLLECTION_SUCCESS';
export const COLLECTIONS_UPDATE_CONSTRAINT_OF_COLLECTION_FAILURE =
  'COLLECTIONS_UPDATE_CONSTRAINT_OF_COLLECTION_FAILURE';
export const COLLECTIONS_UPDATE_CONSTRAINT_OF_COLLECTION_DISMISS_ERROR =
  'COLLECTIONS_UPDATE_CONSTRAINT_OF_COLLECTION_DISMISS_ERROR';
export const COLLECTIONS_DELETE_COLLECTION_CONSTRAINT_BEGIN =
  'COLLECTIONS_DELETE_COLLECTION_CONSTRAINT_BEGIN';
export const COLLECTIONS_DELETE_COLLECTION_CONSTRAINT_SUCCESS =
  'COLLECTIONS_DELETE_COLLECTION_CONSTRAINT_SUCCESS';
export const COLLECTIONS_DELETE_COLLECTION_CONSTRAINT_FAILURE =
  'COLLECTIONS_DELETE_COLLECTION_CONSTRAINT_FAILURE';
export const COLLECTIONS_DELETE_COLLECTION_CONSTRAINT_DISMISS_ERROR =
  'COLLECTIONS_DELETE_COLLECTION_CONSTRAINT_DISMISS_ERROR';
export const COLLECTIONS_CREATE_COLLECTION_CONSTRAINT_BEGIN =
  'COLLECTIONS_CREATE_COLLECTION_CONSTRAINT_BEGIN';
export const COLLECTIONS_CREATE_COLLECTION_CONSTRAINT_SUCCESS =
  'COLLECTIONS_CREATE_COLLECTION_CONSTRAINT_SUCCESS';
export const COLLECTIONS_CREATE_COLLECTION_CONSTRAINT_FAILURE =
  'COLLECTIONS_CREATE_COLLECTION_CONSTRAINT_FAILURE';
export const COLLECTIONS_CREATE_COLLECTION_CONSTRAINT_DISMISS_ERROR =
  'COLLECTIONS_CREATE_COLLECTION_CONSTRAINT_DISMISS_ERROR';
export const COLLECTIONS_ADD_RULE_TO_COLLECTION_BEGIN = 'COLLECTIONS_ADD_RULE_TO_COLLECTION_BEGIN';
export const COLLECTIONS_ADD_RULE_TO_COLLECTION_SUCCESS =
  'COLLECTIONS_ADD_RULE_TO_COLLECTION_SUCCESS';
export const COLLECTIONS_ADD_RULE_TO_COLLECTION_FAILURE =
  'COLLECTIONS_ADD_RULE_TO_COLLECTION_FAILURE';
export const COLLECTIONS_ADD_RULE_TO_COLLECTION_DISMISS_ERROR =
  'COLLECTIONS_ADD_RULE_TO_COLLECTION_DISMISS_ERROR';
export const COLLECTIONS_DELETE_COLLECTION_VALIDATION_BEGIN =
  'COLLECTIONS_DELETE_COLLECTION_VALIDATION_BEGIN';
export const COLLECTIONS_DELETE_COLLECTION_VALIDATION_SUCCESS =
  'COLLECTIONS_DELETE_COLLECTION_VALIDATION_SUCCESS';
export const COLLECTIONS_DELETE_COLLECTION_VALIDATION_FAILURE =
  'COLLECTIONS_DELETE_COLLECTION_VALIDATION_FAILURE';
export const COLLECTIONS_DELETE_COLLECTION_VALIDATION_DISMISS_ERROR =
  'COLLECTIONS_DELETE_COLLECTION_VALIDATION_DISMISS_ERROR';
export const COLLECTIONS_LOAD_COLLECTION_ITEMS_BEGIN = 'COLLECTIONS_LOAD_COLLECTION_ITEMS_BEGIN';
export const COLLECTIONS_LOAD_COLLECTION_ITEMS_SUCCESS =
  'COLLECTIONS_LOAD_COLLECTION_ITEMS_SUCCESS';
export const COLLECTIONS_LOAD_COLLECTION_ITEMS_FAILURE =
  'COLLECTIONS_LOAD_COLLECTION_ITEMS_FAILURE';
export const COLLECTIONS_LOAD_COLLECTION_ITEMS_DISMISS_ERROR =
  'COLLECTIONS_LOAD_COLLECTION_ITEMS_DISMISS_ERROR';
export const COLLECTIONS_SAVE_COLLECTION_ITEM_BEGIN = 'COLLECTIONS_SAVE_COLLECTION_ITEM_BEGIN';
export const COLLECTIONS_SAVE_COLLECTION_ITEM_SUCCESS = 'COLLECTIONS_SAVE_COLLECTION_ITEM_SUCCESS';
export const COLLECTIONS_SAVE_COLLECTION_ITEM_FAILURE = 'COLLECTIONS_SAVE_COLLECTION_ITEM_FAILURE';
export const COLLECTIONS_SAVE_COLLECTION_ITEM_DISMISS_ERROR =
  'COLLECTIONS_SAVE_COLLECTION_ITEM_DISMISS_ERROR';
export const COLLECTIONS_UPDATE_COLLECTION_ITEM_BEGIN = 'COLLECTIONS_UPDATE_COLLECTION_ITEM_BEGIN';
export const COLLECTIONS_UPDATE_COLLECTION_ITEM_SUCCESS =
  'COLLECTIONS_UPDATE_COLLECTION_ITEM_SUCCESS';
export const COLLECTIONS_UPDATE_COLLECTION_ITEM_FAILURE =
  'COLLECTIONS_UPDATE_COLLECTION_ITEM_FAILURE';
export const COLLECTIONS_UPDATE_COLLECTION_ITEM_DISMISS_ERROR =
  'COLLECTIONS_UPDATE_COLLECTION_ITEM_DISMISS_ERROR';
export const COLLECTIONS_DELETE_ITEM_BEGIN = 'COLLECTIONS_DELETE_ITEM_BEGIN';
export const COLLECTIONS_DELETE_ITEM_SUCCESS = 'COLLECTIONS_DELETE_ITEM_SUCCESS';
export const COLLECTIONS_DELETE_ITEM_FAILURE = 'COLLECTIONS_DELETE_ITEM_FAILURE';
export const COLLECTIONS_DELETE_ITEM_DISMISS_ERROR = 'COLLECTIONS_DELETE_ITEM_DISMISS_ERROR';
export const COLLECTIONS_LOAD_ITEM_DETAILS_BEGIN = 'COLLECTIONS_LOAD_ITEM_DETAILS_BEGIN';
export const COLLECTIONS_LOAD_ITEM_DETAILS_SUCCESS = 'COLLECTIONS_LOAD_ITEM_DETAILS_SUCCESS';
export const COLLECTIONS_LOAD_ITEM_DETAILS_FAILURE = 'COLLECTIONS_LOAD_ITEM_DETAILS_FAILURE';
export const COLLECTIONS_LOAD_ITEM_DETAILS_DISMISS_ERROR =
  'COLLECTIONS_LOAD_ITEM_DETAILS_DISMISS_ERROR';
export const COLLECTIONS_LOAD_COLLECTION_ITEM_BEGIN = 'COLLECTIONS_LOAD_COLLECTION_ITEM_BEGIN';
export const COLLECTIONS_LOAD_COLLECTION_ITEM_SUCCESS = 'COLLECTIONS_LOAD_COLLECTION_ITEM_SUCCESS';
export const COLLECTIONS_LOAD_COLLECTION_ITEM_FAILURE = 'COLLECTIONS_LOAD_COLLECTION_ITEM_FAILURE';
export const COLLECTIONS_LOAD_COLLECTION_ITEM_DISMISS_ERROR =
  'COLLECTIONS_LOAD_COLLECTION_ITEM_DISMISS_ERROR';
export const COLLECTIONS_CLOSE_ITEM_DETAIL_PAGE = 'COLLECTIONS_CLOSE_ITEM_DETAIL_PAGE';
export const COLLECTIONS_TOGGLE_COLLECTION_UPDATE = 'COLLECTIONS_TOGGLE_COLLECTION_UPDATE';
export const COLLECTIONS_DELETE_ALL_ITEMS_BEGIN = 'COLLECTIONS_DELETE_ALL_ITEMS_BEGIN';
export const COLLECTIONS_DELETE_ALL_ITEMS_SUCCESS = 'COLLECTIONS_DELETE_ALL_ITEMS_SUCCESS';
export const COLLECTIONS_DELETE_ALL_ITEMS_FAILURE = 'COLLECTIONS_DELETE_ALL_ITEMS_FAILURE';
export const COLLECTIONS_DELETE_ALL_ITEMS_DISMISS_ERROR =
  'COLLECTIONS_DELETE_ALL_ITEMS_DISMISS_ERROR';
export const COLLECTIONS_ADD_WORKFLOW_TO_COLLECTION_BEGIN =
  'COLLECTIONS_ADD_WORKFLOW_TO_COLLECTION_BEGIN';
export const COLLECTIONS_ADD_WORKFLOW_TO_COLLECTION_SUCCESS =
  'COLLECTIONS_ADD_WORKFLOW_TO_COLLECTION_SUCCESS';
export const COLLECTIONS_ADD_WORKFLOW_TO_COLLECTION_FAILURE =
  'COLLECTIONS_ADD_WORKFLOW_TO_COLLECTION_FAILURE';
export const COLLECTIONS_ADD_WORKFLOW_TO_COLLECTION_DISMISS_ERROR =
  'COLLECTIONS_ADD_WORKFLOW_TO_COLLECTION_DISMISS_ERROR';
export const COLLECTIONS_DELETE_COLLECTION_WORKFLOW_BEGIN =
  'COLLECTIONS_DELETE_COLLECTION_WORKFLOW_BEGIN';
export const COLLECTIONS_DELETE_COLLECTION_WORKFLOW_SUCCESS =
  'COLLECTIONS_DELETE_COLLECTION_WORKFLOW_SUCCESS';
export const COLLECTIONS_DELETE_COLLECTION_WORKFLOW_FAILURE =
  'COLLECTIONS_DELETE_COLLECTION_WORKFLOW_FAILURE';
export const COLLECTIONS_DELETE_COLLECTION_WORKFLOW_DISMISS_ERROR =
  'COLLECTIONS_DELETE_COLLECTION_WORKFLOW_DISMISS_ERROR';
export const COLLECTIONS_LOAD_FILTER_DATA_BEGIN = 'COLLECTIONS_LOAD_FILTER_DATA_BEGIN';
export const COLLECTIONS_LOAD_FILTER_DATA_SUCCESS = 'COLLECTIONS_LOAD_FILTER_DATA_SUCCESS';
export const COLLECTIONS_LOAD_FILTER_DATA_FAILURE = 'COLLECTIONS_LOAD_FILTER_DATA_FAILURE';
export const COLLECTIONS_LOAD_FILTER_DATA_DISMISS_ERROR =
  'COLLECTIONS_LOAD_FILTER_DATA_DISMISS_ERROR';
export const COLLECTIONS_LOAD_PROJECT_PLUGINS_BEGIN = 'COLLECTIONS_LOAD_PROJECT_PLUGINS_BEGIN';
export const COLLECTIONS_LOAD_PROJECT_PLUGINS_SUCCESS = 'COLLECTIONS_LOAD_PROJECT_PLUGINS_SUCCESS';
export const COLLECTIONS_LOAD_PROJECT_PLUGINS_FAILURE = 'COLLECTIONS_LOAD_PROJECT_PLUGINS_FAILURE';
export const COLLECTIONS_LOAD_PROJECT_PLUGINS_DISMISS_ERROR =
  'COLLECTIONS_LOAD_PROJECT_PLUGINS_DISMISS_ERROR';
export const COLLECTIONS_LOAD_PROJECT_DETAIL_COLLECTIONS_BEGIN =
  'COLLECTIONS_LOAD_PROJECT_DETAIL_COLLECTIONS_BEGIN';
export const COLLECTIONS_LOAD_PROJECT_DETAIL_COLLECTIONS_SUCCESS =
  'COLLECTIONS_LOAD_PROJECT_DETAIL_COLLECTIONS_SUCCESS';
export const COLLECTIONS_LOAD_PROJECT_DETAIL_COLLECTIONS_FAILURE =
  'COLLECTIONS_LOAD_PROJECT_DETAIL_COLLECTIONS_FAILURE';
export const COLLECTIONS_LOAD_PROJECT_DETAIL_COLLECTIONS_DISMISS_ERROR =
  'COLLECTIONS_LOAD_PROJECT_DETAIL_COLLECTIONS_DISMISS_ERROR';
export const COLLECTIONS_CREATE_COLLECTION_WITH_CSV_BEGIN =
  'COLLECTIONS_CREATE_COLLECTION_WITH_CSV_BEGIN';
export const COLLECTIONS_CREATE_COLLECTION_WITH_CSV_SUCCESS =
  'COLLECTIONS_CREATE_COLLECTION_WITH_CSV_SUCCESS';
export const COLLECTIONS_CREATE_COLLECTION_WITH_CSV_FAILURE =
  'COLLECTIONS_CREATE_COLLECTION_WITH_CSV_FAILURE';
export const COLLECTIONS_CREATE_COLLECTION_WITH_CSV_DISMISS_ERROR =
  'COLLECTIONS_CREATE_COLLECTION_WITH_CSV_DISMISS_ERROR';
export const COLLECTIONS_TOGGLE_IS_OPEN_COLLECTION_CREATE_WITH_CSV =
  'COLLECTIONS_TOGGLE_IS_OPEN_COLLECTION_CREATE_WITH_CSV';
export const COLLECTIONS_IS_OPEN_COLLECTION_CREATE_WITH_REST_API =
  'COLLECTIONS_IS_OPEN_COLLECTION_CREATE_WITH_REST_API';
export const COLLECTIONS_RESPONCE_FOR_REST_API_BEGIN = 'COLLECTIONS_RESPONCE_FOR_REST_API_BEGIN';
export const COLLECTIONS_RESPONCE_FOR_REST_API_SUCCESS =
  'COLLECTIONS_RESPONCE_FOR_REST_API_SUCCESS';
export const COLLECTIONS_RESPONCE_FOR_REST_API_FAILURE =
  'COLLECTIONS_RESPONCE_FOR_REST_API_FAILURE';
export const COLLECTIONS_RESPONCE_FOR_REST_API_DISMISS_ERROR =
  'COLLECTIONS_RESPONCE_FOR_REST_API_DISMISS_ERROR';
export const COLLECTIONS_GET_DATA_FROM_APPWRITE_SUCCESS =
  'COLLECTIONS_GET_DATA_FROM_APPWRITE_SUCCESS';
export const COLLECTIONS_GET_DATA_FROM_APPWRITE_FAILURE =
  'COLLECTIONS_GET_DATA_FROM_APPWRITE_FAILURE';
export const COLLECTIONS_GET_DATA_FROM_APPWRITE_DISMISS_ERROR =
  'COLLECTIONS_GET_DATA_FROM_APPWRITE_DISMISS_ERROR';
export const COLLECTIONS_GETDATA_FOR_APPWRITE_COLLECTIONS_BEGIN =
  'COLLECTIONS_GETDATA_FOR_APPWRITE_COLLECTIONS_BEGIN';
export const COLLECTIONS_GETDATA_FOR_APPWRITE_COLLECTIONS_SUCCESS =
  'COLLECTIONS_GETDATA_FOR_APPWRITE_COLLECTIONS_SUCCESS';
export const COLLECTIONS_GETDATA_FOR_APPWRITE_COLLECTIONS_FAILURE =
  'COLLECTIONS_GETDATA_FOR_APPWRITE_COLLECTIONS_FAILURE';
export const COLLECTIONS_GETDATA_FOR_APPWRITE_COLLECTIONS_DISMISS_ERROR =
  'COLLECTIONS_GETDATA_FOR_APPWRITE_COLLECTIONS_DISMISS_ERROR';
export const COLLECTIONS_SAVE_DATA_IN_EXTERNALDATABASE_BEGIN =
  'COLLECTIONS_SAVE_DATA_IN_EXTERNALDATABASE_BEGIN';
export const COLLECTIONS_SAVE_DATA_IN_EXTERNALDATABASE_SUCCESS =
  'COLLECTIONS_SAVE_DATA_IN_EXTERNALDATABASE_SUCCESS';
export const COLLECTIONS_SAVE_DATA_IN_EXTERNALDATABASE_FAILURE =
  'COLLECTIONS_SAVE_DATA_IN_EXTERNALDATABASE_FAILURE';
export const COLLECTIONS_SAVE_DATA_IN_EXTERNALDATABASE_DISMISS_ERROR =
  'COLLECTIONS_SAVE_DATA_IN_EXTERNALDATABASE_DISMISS_ERROR';
export const COLLECTIONS_LOAD_EXTERNAL_DATABASE_BEGIN = 'COLLECTIONS_LOAD_EXTERNAL_DATABASE_BEGIN';
export const COLLECTIONS_LOAD_EXTERNAL_DATABASE_SUCCESS =
  'COLLECTIONS_LOAD_EXTERNAL_DATABASE_SUCCESS';
export const COLLECTIONS_LOAD_EXTERNAL_DATABASE_FAILURE =
  'COLLECTIONS_LOAD_EXTERNAL_DATABASE_FAILURE';
export const COLLECTIONS_LOAD_EXTERNAL_DATABASE_DISMISS_ERROR =
  'COLLECTIONS_LOAD_EXTERNAL_DATABASE_DISMISS_ERROR';
export const COLLECTIONS_UPDATE_EXTERNAL_DATABASE_BEGIN =
  'COLLECTIONS_UPDATE_EXTERNAL_DATABASE_BEGIN';
export const COLLECTIONS_UPDATE_EXTERNAL_DATABASE_SUCCESS =
  'COLLECTIONS_UPDATE_EXTERNAL_DATABASE_SUCCESS';
export const COLLECTIONS_UPDATE_EXTERNAL_DATABASE_FAILURE =
  'COLLECTIONS_UPDATE_EXTERNAL_DATABASE_FAILURE';
export const COLLECTIONS_UPDATE_EXTERNAL_DATABASE_DISMISS_ERROR =
  'COLLECTIONS_UPDATE_EXTERNAL_DATABASE_DISMISS_ERROR';
export const COLLECTIONS_CREATE_COLLECTION_WITH_APPWRITE_BEGIN =
  'COLLECTIONS_CREATE_COLLECTION_WITH_APPWRITE_BEGIN';
export const COLLECTIONS_CREATE_COLLECTION_WITH_APPWRITE_SUCCESS =
  'COLLECTIONS_CREATE_COLLECTION_WITH_APPWRITE_SUCCESS';
export const COLLECTIONS_CREATE_COLLECTION_WITH_APPWRITE_FAILURE =
  'COLLECTIONS_CREATE_COLLECTION_WITH_APPWRITE_FAILURE';
export const COLLECTIONS_CREATE_COLLECTION_WITH_APPWRITE_DISMISS_ERROR =
  'COLLECTIONS_CREATE_COLLECTION_WITH_APPWRITE_DISMISS_ERROR';
export const COLLECTIONS_CLONE_COLLECTION_BEGIN = 'COLLECTIONS_CLONE_COLLECTION_BEGIN';
export const COLLECTIONS_CLONE_COLLECTION_SUCCESS = 'COLLECTIONS_CLONE_COLLECTION_SUCCESS';
export const COLLECTIONS_CLONE_COLLECTION_FAILURE = 'COLLECTIONS_CLONE_COLLECTION_FAILURE';
export const COLLECTIONS_CLONE_COLLECTION_DISMISS_ERROR =
  'COLLECTIONS_CLONE_COLLECTION_DISMISS_ERROR';
export const COLLECTIONS_CREATE_COLLECTION_WITH_JSON_BEGIN =
  'COLLECTIONS_CREATE_COLLECTION_WITH_JSON_BEGIN';
export const COLLECTIONS_CREATE_COLLECTION_WITH_JSON_SUCCESS =
  'COLLECTIONS_CREATE_COLLECTION_WITH_JSON_SUCCESS';
export const COLLECTIONS_CREATE_COLLECTION_WITH_JSON_FAILURE =
  'COLLECTIONS_CREATE_COLLECTION_WITH_JSON_FAILURE';
export const COLLECTIONS_CREATE_COLLECTION_WITH_JSON_DISMISS_ERROR =
  'COLLECTIONS_CREATE_COLLECTION_WITH_JSON_DISMISS_ERROR';
export const COLLECTIONS_IMPORT_ITEMS_FROM_JSON_BEGIN = 'COLLECTIONS_IMPORT_ITEMS_FROM_JSON_BEGIN';
export const COLLECTIONS_IMPORT_ITEMS_FROM_JSON_SUCCESS =
  'COLLECTIONS_IMPORT_ITEMS_FROM_JSON_SUCCESS';
export const COLLECTIONS_IMPORT_ITEMS_FROM_JSON_FAILURE =
  'COLLECTIONS_IMPORT_ITEMS_FROM_JSON_FAILURE';
export const COLLECTIONS_IMPORT_ITEMS_FROM_JSON_DISMISS_ERROR =
  'COLLECTIONS_IMPORT_ITEMS_FROM_JSON_DISMISS_ERROR';
export const COLLECTIONS_IMPORT_ITEMS_FROM_REST_API_BEGIN =
  'COLLECTIONS_IMPORT_ITEMS_FROM_REST_API_BEGIN';
export const COLLECTIONS_IMPORT_ITEMS_FROM_REST_API_SUCCESS =
  'COLLECTIONS_IMPORT_ITEMS_FROM_REST_API_SUCCESS';
export const COLLECTIONS_IMPORT_ITEMS_FROM_REST_API_FAILURE =
  'COLLECTIONS_IMPORT_ITEMS_FROM_REST_API_FAILURE';
export const COLLECTIONS_IMPORT_ITEMS_FROM_REST_API_DISMISS_ERROR =
  'COLLECTIONS_IMPORT_ITEMS_FROM_REST_API_DISMISS_ERROR';
export const COLLECTIONS_DELETE_COLLECTION_VALIDATION_RULES_BEGIN =
  'COLLECTIONS_DELETE_COLLECTION_VALIDATION_RULES_BEGIN';
export const COLLECTIONS_DELETE_COLLECTION_VALIDATION_RULES_SUCCESS =
  'COLLECTIONS_DELETE_COLLECTION_VALIDATION_RULES_SUCCESS';
export const COLLECTIONS_DELETE_COLLECTION_VALIDATION_RULES_FAILURE =
  'COLLECTIONS_DELETE_COLLECTION_VALIDATION_RULES_FAILURE';
export const COLLECTIONS_DELETE_COLLECTION_VALIDATION_RULES_DISMISS_ERROR =
  'COLLECTIONS_DELETE_COLLECTION_VALIDATION_RULES_DISMISS_ERROR';
export const COLLECTIONS_ADD_SINGLE_VALIDATION_RULE_BEGIN =
  'COLLECTIONS_ADD_SINGLE_VALIDATION_RULE_BEGIN';
export const COLLECTIONS_ADD_SINGLE_VALIDATION_RULE_SUCCESS =
  'COLLECTIONS_ADD_SINGLE_VALIDATION_RULE_SUCCESS';
export const COLLECTIONS_ADD_SINGLE_VALIDATION_RULE_FAILURE =
  'COLLECTIONS_ADD_SINGLE_VALIDATION_RULE_FAILURE';
export const COLLECTIONS_ADD_SINGLE_VALIDATION_RULE_DISMISS_ERROR =
  'COLLECTIONS_ADD_SINGLE_VALIDATION_RULE_DISMISS_ERROR';
export const COLLECTIONS_UPDATE_LOOKUP_BEGIN = 'COLLECTIONS_UPDATE_LOOKUP_BEGIN';
export const COLLECTIONS_UPDATE_LOOKUP_SUCCESS = 'COLLECTIONS_UPDATE_LOOKUP_SUCCESS';
export const COLLECTIONS_UPDATE_LOOKUP_FAILURE = 'COLLECTIONS_UPDATE_LOOKUP_FAILURE';
export const COLLECTIONS_UPDATE_LOOKUP_DISMISS_ERROR = 'COLLECTIONS_UPDATE_LOOKUP_DISMISS_ERROR';
export const COLLECTIONS_ENABLE_LOOKUP_SETTING_BEGIN = 'COLLECTIONS_ENABLE_LOOKUP_SETTING_BEGIN';
export const COLLECTIONS_ENABLE_LOOKUP_SETTING_SUCCESS =
  'COLLECTIONS_ENABLE_LOOKUP_SETTING_SUCCESS';
export const COLLECTIONS_ENABLE_LOOKUP_SETTING_FAILURE =
  'COLLECTIONS_ENABLE_LOOKUP_SETTING_FAILURE';
export const COLLECTIONS_ENABLE_LOOKUP_SETTING_DISMISS_ERROR =
  'COLLECTIONS_ENABLE_LOOKUP_SETTING_DISMISS_ERROR';
export const COLLECTIONS_GET_PERMISSION_FLAGS_BEGIN = 'COLLECTIONS_GET_PERMISSION_FLAGS_BEGIN';
export const COLLECTIONS_GET_PERMISSION_FLAGS_SUCCESS = 'COLLECTIONS_GET_PERMISSION_FLAGS_SUCCESS';
export const COLLECTIONS_GET_PERMISSION_FLAGS_FAILURE = 'COLLECTIONS_GET_PERMISSION_FLAGS_FAILURE';
export const COLLECTIONS_GET_PERMISSION_FLAGS_DISMISS_ERROR =
  'COLLECTIONS_GET_PERMISSION_FLAGS_DISMISS_ERROR';
export const COLLECTIONS_UPDATE_FILTER_DETAILS_BEGIN = 'COLLECTIONS_UPDATE_FILTER_DETAILS_BEGIN';
export const COLLECTIONS_UPDATE_FILTER_DETAILS_SUCCESS =
  'COLLECTIONS_UPDATE_FILTER_DETAILS_SUCCESS';
export const COLLECTIONS_UPDATE_FILTER_DETAILS_FAILURE =
  'COLLECTIONS_UPDATE_FILTER_DETAILS_FAILURE';
export const COLLECTIONS_UPDATE_FILTER_DETAILS_DISMISS_ERROR =
  'COLLECTIONS_UPDATE_FILTER_DETAILS_DISMISS_ERROR';
export const COLLECTIONS_CREATE_COLLECTION_SNAPSHOT_BEGIN =
  'COLLECTIONS_CREATE_COLLECTION_SNAPSHOT_BEGIN';
export const COLLECTIONS_CREATE_COLLECTION_SNAPSHOT_SUCCESS =
  'COLLECTIONS_CREATE_COLLECTION_SNAPSHOT_SUCCESS';
export const COLLECTIONS_CREATE_COLLECTION_SNAPSHOT_FAILURE =
  'COLLECTIONS_CREATE_COLLECTION_SNAPSHOT_FAILURE';
export const COLLECTIONS_CREATE_COLLECTION_SNAPSHOT_DISMISS_ERROR =
  'COLLECTIONS_CREATE_COLLECTION_SNAPSHOT_DISMISS_ERROR';
export const COLLECTIONS_LOAD_COLLECTION_SNAPSHOTS_BEGIN =
  'COLLECTIONS_LOAD_COLLECTION_SNAPSHOTS_BEGIN';
export const COLLECTIONS_LOAD_COLLECTION_SNAPSHOTS_SUCCESS =
  'COLLECTIONS_LOAD_COLLECTION_SNAPSHOTS_SUCCESS';
export const COLLECTIONS_LOAD_COLLECTION_SNAPSHOTS_FAILURE =
  'COLLECTIONS_LOAD_COLLECTION_SNAPSHOTS_FAILURE';
export const COLLECTIONS_LOAD_COLLECTION_SNAPSHOTS_DISMISS_ERROR =
  'COLLECTIONS_LOAD_COLLECTION_SNAPSHOTS_DISMISS_ERROR';
export const COLLECTIONS_CREATE_PERMISSION_LEVEL_SECURITY_IN_COLLECTION_BEGIN =
  'COLLECTIONS_CREATE_PERMISSION_LEVEL_SECURITY_IN_COLLECTION_BEGIN';
export const COLLECTIONS_CREATE_PERMISSION_LEVEL_SECURITY_IN_COLLECTION_SUCCESS =
  'COLLECTIONS_CREATE_PERMISSION_LEVEL_SECURITY_IN_COLLECTION_SUCCESS';
export const COLLECTIONS_CREATE_PERMISSION_LEVEL_SECURITY_IN_COLLECTION_FAILURE =
  'COLLECTIONS_CREATE_PERMISSION_LEVEL_SECURITY_IN_COLLECTION_FAILURE';
export const COLLECTIONS_CREATE_PERMISSION_LEVEL_SECURITY_IN_COLLECTION_DISMISS_ERROR =
  'COLLECTIONS_CREATE_PERMISSION_LEVEL_SECURITY_IN_COLLECTION_DISMISS_ERROR';
export const COLLECTIONS_CREATE_ROW_LEVEL_SECURITY_FILTER_IN_COLLECTION_BEGIN =
  'COLLECTIONS_CREATE_ROW_LEVEL_SECURITY_FILTER_IN_COLLECTION_BEGIN';
export const COLLECTIONS_CREATE_ROW_LEVEL_SECURITY_FILTER_IN_COLLECTION_SUCCESS =
  'COLLECTIONS_CREATE_ROW_LEVEL_SECURITY_FILTER_IN_COLLECTION_SUCCESS';
export const COLLECTIONS_CREATE_ROW_LEVEL_SECURITY_FILTER_IN_COLLECTION_FAILURE =
  'COLLECTIONS_CREATE_ROW_LEVEL_SECURITY_FILTER_IN_COLLECTION_FAILURE';
export const COLLECTIONS_CREATE_ROW_LEVEL_SECURITY_FILTER_IN_COLLECTION_DISMISS_ERROR =
  'COLLECTIONS_CREATE_ROW_LEVEL_SECURITY_FILTER_IN_COLLECTION_DISMISS_ERROR';
export const COLLECTIONS_DELETE_ROW_LEVEL_SECURITY_FILTER_BEGIN =
  'COLLECTIONS_DELETE_ROW_LEVEL_SECURITY_FILTER_BEGIN';
export const COLLECTIONS_DELETE_ROW_LEVEL_SECURITY_FILTER_SUCCESS =
  'COLLECTIONS_DELETE_ROW_LEVEL_SECURITY_FILTER_SUCCESS';
export const COLLECTIONS_DELETE_ROW_LEVEL_SECURITY_FILTER_FAILURE =
  'COLLECTIONS_DELETE_ROW_LEVEL_SECURITY_FILTER_FAILURE';
export const COLLECTIONS_DELETE_ROW_LEVEL_SECURITY_FILTER_DISMISS_ERROR =
  'COLLECTIONS_DELETE_ROW_LEVEL_SECURITY_FILTER_DISMISS_ERROR';
export const COLLECTIONS_UPDATE_TABLE_SETTINGS_BEGIN = 'COLLECTIONS_UPDATE_TABLE_SETTINGS_BEGIN';
export const COLLECTIONS_UPDATE_TABLE_SETTINGS_SUCCESS =
  'COLLECTIONS_UPDATE_TABLE_SETTINGS_SUCCESS';
export const COLLECTIONS_UPDATE_TABLE_SETTINGS_FAILURE =
  'COLLECTIONS_UPDATE_TABLE_SETTINGS_FAILURE';
export const COLLECTIONS_UPDATE_TABLE_SETTINGS_DISMISS_ERROR =
  'COLLECTIONS_UPDATE_TABLE_SETTINGS_DISMISS_ERROR';
export const COLLECTIONS_GET_TABLE_SETTINGS_BEGIN = 'COLLECTIONS_GET_TABLE_SETTINGS_BEGIN';
export const COLLECTIONS_GET_TABLE_SETTINGS_SUCCESS = 'COLLECTIONS_GET_TABLE_SETTINGS_SUCCESS';
export const COLLECTIONS_GET_TABLE_SETTINGS_FAILURE = 'COLLECTIONS_GET_TABLE_SETTINGS_FAILURE';
export const COLLECTIONS_GET_TABLE_SETTINGS_DISMISS_ERROR =
  'COLLECTIONS_GET_TABLE_SETTINGS_DISMISS_ERROR';
export const COLLECTIONS_CREATE_TYPESENSE_MAPPING_IN_COLLECTION_BEGIN =
  'COLLECTIONS_CREATE_TYPESENSE_MAPPING_IN_COLLECTION_BEGIN';
export const COLLECTIONS_CREATE_TYPESENSE_MAPPING_IN_COLLECTION_SUCCESS =
  'COLLECTIONS_CREATE_TYPESENSE_MAPPING_IN_COLLECTION_SUCCESS';
export const COLLECTIONS_CREATE_TYPESENSE_MAPPING_IN_COLLECTION_FAILURE =
  'COLLECTIONS_CREATE_TYPESENSE_MAPPING_IN_COLLECTION_FAILURE';
export const COLLECTIONS_CREATE_TYPESENSE_MAPPING_IN_COLLECTION_DISMISS_ERROR =
  'COLLECTIONS_CREATE_TYPESENSE_MAPPING_IN_COLLECTION_DISMISS_ERROR';
export const COLLECTIONS_GENERATE_CRUD_PAGES_BEGIN = 'COLLECTIONS_GENERATE_CRUD_PAGES_BEGIN';
export const COLLECTIONS_GENERATE_CRUD_PAGES_SUCCESS = 'COLLECTIONS_GENERATE_CRUD_PAGES_SUCCESS';
export const COLLECTIONS_GENERATE_CRUD_PAGES_FAILURE = 'COLLECTIONS_GENERATE_CRUD_PAGES_FAILURE';
export const COLLECTIONS_GENERATE_CRUD_PAGES_DISMISS_ERROR =
  'COLLECTIONS_GENERATE_CRUD_PAGES_DISMISS_ERROR';
export const COLLECTIONS_CREATE_COLLECTION_WITH_PROMPT_BEGIN = 'COLLECTIONS_CREATE_COLLECTION_WITH_PROMPT_BEGIN';
export const COLLECTIONS_CREATE_COLLECTION_WITH_PROMPT_SUCCESS = 'COLLECTIONS_CREATE_COLLECTION_WITH_PROMPT_SUCCESS';
export const COLLECTIONS_CREATE_COLLECTION_WITH_PROMPT_FAILURE = 'COLLECTIONS_CREATE_COLLECTION_WITH_PROMPT_FAILURE';
export const COLLECTIONS_CREATE_COLLECTION_WITH_PROMPT_DISMISS_ERROR = 'COLLECTIONS_CREATE_COLLECTION_WITH_PROMPT_DISMISS_ERROR';
export const COLLECTIONS_EXTRACT_FIELDS_FROM_PROMPT_BEGIN = 'COLLECTIONS_EXTRACT_FIELDS_FROM_PROMPT_BEGIN';
export const COLLECTIONS_EXTRACT_FIELDS_FROM_PROMPT_SUCCESS = 'COLLECTIONS_EXTRACT_FIELDS_FROM_PROMPT_SUCCESS';
export const COLLECTIONS_EXTRACT_FIELDS_FROM_PROMPT_FAILURE = 'COLLECTIONS_EXTRACT_FIELDS_FROM_PROMPT_FAILURE';
export const COLLECTIONS_EXTRACT_FIELDS_FROM_PROMPT_DISMISS_ERROR = 'COLLECTIONS_EXTRACT_FIELDS_FROM_PROMPT_DISMISS_ERROR';
export const COLLECTIONS_TOGGLE_IS_OPEN_PROMPT_CREATE = 'COLLECTIONS_TOGGLE_IS_OPEN_PROMPT_CREATE';
export const COLLECTIONS_EXTRACT_COLLECTION_DATA_BEGIN = 'COLLECTIONS_EXTRACT_COLLECTION_DATA_BEGIN';
export const COLLECTIONS_EXTRACT_COLLECTION_DATA_SUCCESS = 'COLLECTIONS_EXTRACT_COLLECTION_DATA_SUCCESS';
export const COLLECTIONS_EXTRACT_COLLECTION_DATA_FAILURE = 'COLLECTIONS_EXTRACT_COLLECTION_DATA_FAILURE';
export const COLLECTIONS_EXTRACT_COLLECTION_DATA_DISMISS_ERROR = 'COLLECTIONS_EXTRACT_COLLECTION_DATA_DISMISS_ERROR';
export const COLLECTIONS_GENERATE_COLLECTION_DATA_BEGIN = 'COLLECTIONS_GENERATE_COLLECTION_DATA_BEGIN';
export const COLLECTIONS_GENERATE_COLLECTION_DATA_SUCCESS = 'COLLECTIONS_GENERATE_COLLECTION_DATA_SUCCESS';
export const COLLECTIONS_GENERATE_COLLECTION_DATA_FAILURE = 'COLLECTIONS_GENERATE_COLLECTION_DATA_FAILURE';
export const COLLECTIONS_GENERATE_COLLECTION_DATA_DISMISS_ERROR = 'COLLECTIONS_GENERATE_COLLECTION_DATA_DISMISS_ERROR';
export const COLLECTIONS_CREATE_META_DATA_MAPPING_IN_COLLECTION_BEGIN =
  'COLLECTIONS_CREATE_META_DATA_MAPPING_IN_COLLECTION_BEGIN';
export const COLLECTIONS_CREATE_META_DATA_MAPPING_IN_COLLECTION_SUCCESS =
  'COLLECTIONS_CREATE_META_DATA_MAPPING_IN_COLLECTION_SUCCESS';
export const COLLECTIONS_CREATE_META_DATA_MAPPING_IN_COLLECTION_FAILURE =
  'COLLECTIONS_CREATE_META_DATA_MAPPING_IN_COLLECTION_FAILURE';
export const COLLECTIONS_CREATE_META_DATA_MAPPING_IN_COLLECTION_DISMISS_ERROR =
  'COLLECTIONS_CREATE_META_DATA_MAPPING_IN_COLLECTION_DISMISS_ERROR';
export const COLLECTIONS_DELETE_COLLECTION_META_DATA_TABLE_MAPPING_BEGIN =
  'COLLECTIONS_DELETE_COLLECTION_META_DATA_TABLE_MAPPING_BEGIN';
export const COLLECTIONS_DELETE_COLLECTION_META_DATA_TABLE_MAPPING_SUCCESS =
  'COLLECTIONS_DELETE_COLLECTION_META_DATA_TABLE_MAPPING_SUCCESS';
export const COLLECTIONS_DELETE_COLLECTION_META_DATA_TABLE_MAPPING_FAILURE =
  'COLLECTIONS_DELETE_COLLECTION_META_DATA_TABLE_MAPPING_FAILURE';
export const COLLECTIONS_DELETE_COLLECTION_META_DATA_TABLE_MAPPING_DISMISS_ERROR =
  'COLLECTIONS_DELETE_COLLECTION_META_DATA_TABLE_MAPPING_DISMISS_ERROR';
export const COLLECTIONS_UPDATE_COLLECTION_META_DATA_TABLE_MAPPING_BEGIN =
  'COLLECTIONS_UPDATE_COLLECTION_META_DATA_TABLE_MAPPING_BEGIN';
export const COLLECTIONS_UPDATE_COLLECTION_META_DATA_TABLE_MAPPING_SUCCESS =
  'COLLECTIONS_UPDATE_COLLECTION_META_DATA_TABLE_MAPPING_SUCCESS';
export const COLLECTIONS_UPDATE_COLLECTION_META_DATA_TABLE_MAPPING_FAILURE =
  'COLLECTIONS_UPDATE_COLLECTION_META_DATA_TABLE_MAPPING_FAILURE';
export const COLLECTIONS_UPDATE_COLLECTION_META_DATA_TABLE_MAPPING_DISMISS_ERROR =
  'COLLECTIONS_UPDATE_COLLECTION_META_DATA_TABLE_MAPPING_DISMISS_ERROR';
